import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sent-password',
  templateUrl: './sent-password.component.html',
  styleUrl: './sent-password.component.scss'
})
export class SentPasswordComponent {
  constructor(public translateService: TranslateService) {}

  getYear() {
    return new Date().getFullYear();
  }
}
